<template>
  <div id="block" class="w3lvide-content">
    <div class="workinghny-form-grid">
      <div class="main-hotair">
        <div class="content-wthree">
          <div class="login-register">
            <h1>请选择操作</h1>
            <form @submit.prevent="handleLogin">
              <input 
                type="tel" 
                class="text" 
                v-model="loginForm.phone" 
                placeholder="手机号" 
                required 
                autofocus 
                pattern="\d{11}" 
                title="请输入11位手机号"
              >
              <input 
                type="password" 
                class="password" 
                v-model="loginForm.password" 
                placeholder="密码" 
                required
              >
              <div class="buttons">
                <button class="btn login-btn" type="submit">来登录</button>
                <button class="btn register-btn" type="button" @click="handleRegister">来注册</button>
              </div>
            </form>
          </div>

          <p class="continue"><span>或者</span></p>
          <div class="social-login">
            <button class="social-login-1" @click="handleGuestLogin">我是游客</button>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <p class="copy-footer-29">饿了怎么办  |  <a href="#" title="鸡公煲">润泽鸡公煲</a></p>
      <p class="beian">备案号  |  <a href="https://beian.miit.gov.cn/" target="_blank">冀ICP备2025106185号</a></p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        phone: '',
        password: ''
      }
    }
  },
  methods: {
    async handleLogin() {
      try {
        const res = await axios.post('/api/user/login', this.loginForm)
        if (res.data.code === 444) {
          alert(res.data.message)
          return
        }
        alert('登录成功！')
        
        // 保存用户信息
        localStorage.setItem('isGuest', 'false')
        localStorage.setItem('userId', res.data.data.userId)
        localStorage.setItem('nickname', res.data.data.nickname)
        
        // 保存管理员信息
        const isAdmin = res.data.data.isAdmin
        localStorage.setItem('isAdmin', isAdmin)
        
        // 重要：保存 token
        if (res.data.data.token) {
          localStorage.setItem('token', res.data.data.token)
          console.log('保存token:', res.data.data.token)
        }
        
        if (isAdmin === 1) {
          this.$router.push('/userManager')
        } else {
          this.$router.push('/select-shitang')
        }
      } catch (error) {
        console.error('登录失败:', error)
        alert('登录失败，请检查网络或用户名密码')
      }
    },
    async handleRegister() {
      // 注册逻辑可以根据需要完善，这里简单调用登录接口模拟（或者如果有专门的注册接口）
      alert('功能开发中...')
    },
    async handleGuestLogin() {
      const nickname = prompt("请输入您的昵称:")
      if (nickname) {
        try {
          const res = await axios.post('/api/user/login/temporary', { nickname })
          if (res.data.code === 444) {
            alert(res.data.message)
            return
          }
          
          // 保存游客信息
          localStorage.setItem('nickname', nickname)
          localStorage.setItem('isGuest', 'true')
          
          // 重要：保存 token
          if (res.data.data && res.data.data.token) {
            localStorage.setItem('token', res.data.data.token)
            console.log('保存游客token:', res.data.data.token)
          }
          
          alert("欢迎，" + nickname + "!")
          this.$router.push('/select-shitang')
        } catch (error) {
          console.error('提交失败:', error)
          alert('提交失败')
        }
      } else {
        alert("您没有输入昵称。")
      }
    }
  }
}
</script>

<style scoped>
#block {
  background: url('~@/assets/images/freelan.jpg') no-repeat center center fixed;
  background-size: cover;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* 覆盖 style.css 中的部分样式以适应 Vue 结构 */
.workinghny-form-grid {
  position: relative;
  top: 0;
}
</style>
